import consts from "@/consts.js";
import Request from './request';

async function fetch(data) {
    return Request('get', "api/roles/", data);
}

async function fetchOne(id) {// 获取单个
    return Request('get', "api/roles/" + id);
}

async function fetchAll(data) {
    if (!data) data = {};
    data.limit = consts.limitAll; //获取全部
    return Request('get', "api/roles", data);
}

async function fetchAllForSelect(data) {
    if (!data) data = {};
    data.limit = consts.limitAll; //获取全部
    data.fieldFilter = ["id", "role_name"]; //仅筛选少许必要字段
    return Request('get', "api/roles/select", data, false, false, true);
}

async function save(id,data) {// 编辑或新建数据（有id为编辑，没有id为新建）
    if (id) {
        return Request('post', "api/roles/edit?id=" + id, data);
    } else {
        return Request('post', "api/roles/add" , data);
    }
}

async function del(id) {// 删除数据
    return Request('delete', "api/roles/delete/" + id);
}

async function getPermissionTree() {// 获取所有权限
    return Request('get', "api/roles/getPermissionTree");
}

async function getBusinessPermission() {// 获取所有权限
    return Request('get', "api/roles/get-business-permission");
}

export default {
    fetch,
    fetchOne,
    fetchAll,
    fetchAllForSelect,
    save,
    del,
    getPermissionTree,
    getBusinessPermission,
};